module.exports = {
      id: "user-icon-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "svg-sprite-b35941cc40d7fc0f39708cadaf87d26a.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }